import { getCommonQuery as n, graphRequest as r } from "../util/graphql.mjs";
async function i(e) {
  const o = {
    ...n(e),
    orderBy: e?.orderBy ?? "timestamp",
    orderDirection: e?.orderDirection ?? "desc",
    where: {
      ...e?.where,
      account: e?.where?.account ?? e?.address
    }
  };
  return await r(
    (t) => `
  {
    transactions(${t}) {
      id
      account
      action
      txHash
      outTokens{
        token
        address
        amount
        optionType
        strikePrice
        exerciseTimestamp
        poolId
        OTCPrice
        OTCBuyToken
        openTimestamp
      }
      inTokens{
        token
        address
        amount
        optionType
        strikePrice
        exerciseTimestamp
        poolId
        OTCPrice
        OTCBuyToken
        openTimestamp
      }
      fees
      feeToken
      fees2
      fee2Token
      timestamp
      optionType
      strikePrice
      exerciseTimestamp
      poolId
      contract
      contractAddress
    }
  }
`,
    o
  ).then((t) => t?.transactions ?? []);
}
export {
  i as getTransactionList
};
//# sourceMappingURL=trade.mjs.map
